const Biggertext = () => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="96" height="96" rx="48" />
      <path
        d="M18.7578 30.1546L18.7578 25.7863C18.7578 22.8356 21.1589 20.4346 24.1096 20.4346L61.4852 20.4346C64.4359 20.4346 66.837 22.8356 66.837 25.7863L66.837 30.1546"
        stroke="black"
        strokeWidth="5.20713"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.793 65.3608L42.793 22.6045"
        stroke="black"
        strokeWidth="5.20713"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.957 65.3604L49.0991 65.3604"
        stroke="black"
        strokeWidth="5.20713"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.5742 42.9116L72.8531 42.9116C74.9649 42.9116 76.6717 44.6184 76.6717 46.7302L76.6717 49.0445"
        stroke="black"
        strokeWidth="5.20713"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.5156 74.9928L59.5156 44.4443"
        stroke="black"
        strokeWidth="5.20713"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.3242 74.9937L65.7056 74.9937"
        stroke="black"
        strokeWidth="5.20713"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Biggertext;
